







import React from "react";
import { Link } from "react-router-dom";
import "../styles/Statistics.css";

// Import your icon and images
import statisticsIcon from "../assets/icons/statistics-icon.png";
import statisticsImage from "../image/Statistics-image.png";
import pieChartImage from "../image/stats-pie-chart.png";

const Statistics = () => {
  return (
    <div className="stats-container">
      {/* Image Slider */}
      <div className="stats-image-slider">
        <img src={statisticsImage} alt="Statistics Slider" />
      </div>

      {/* Main Content Container */}
      <div className="stats-content">
        {/* Content Card with title inside */}
        <div className="stats-card">
          {/* Ship wheel icon and title */}
          <div className="stats-header-container">
            <img src={statisticsIcon} alt="Statistics" className="stats-wheel-icon" />
            <div className="stats-header-title">Statistics</div>
          </div>
          
          {/* Content */}
          <div className="stats-text-content">
            <p className="stats-text">
              The Breakbulk and Project sailing services provided by ECL Shipping transcends all tangible targets set by themselves. ECL Shipping's proven track records speak for their growth without boundaries.
            </p>
            
            <h3 className="stats-subtitle">Salient Features :</h3>
            <ol className="stats-list-numbered">
              <li>Liner service from India to Far East, including S.E. Asia, China, Korea and Japan.</li>
              <li>Services Bulk, Break-Bulk, Projects and Automobile Industry.</li>
              <li>Handles about 160 vessels per year, import and export.</li>
              <li>Mobilizes in excess of one million freight tons of export cargo annually.</li>
              <li>Offices and Agents in all major ports of India.</li>
              <li>Owns and operates Equipment's includes Cranes, Fork Lifts, Trailers.</li>
            </ol>
            
            <h3 className="stats-subtitle">Annual Export Volume :</h3>
            <ul className="stats-list-bulleted">
              <li>1 Million tons Granite</li>
              <li>150000 Frt Ferro Chrome, Ilmenite and other Bulk</li>
              <li>100000 Frt Agri Product</li>
              <li>50000 Frt RORO / LOLO</li>
              <li>10000 Frt Project Cargo</li>
            </ul>
            
            {/* Pie chart image */}
            <div className="stats-chart-container">
              <img src={pieChartImage} alt="Export Volume Pie Chart" className="stats-pie-chart" />
            </div>
          </div>
          
          {/* Right Side Panel */}
          <div className="stats-side-panel">
            <Link to="/overview" className="stats-panel-link">
              <div className="stats-panel-section">
                <h4 className="stats-panel-title">Overview :</h4>
                <p className="stats-panel-text">
                  ECL Shipping India Pvt Ltd, was established in 2006 as a joint venture of PUYVAST MARITIME INDIA PVT LTD and ECL (Singapore) Pte Ltd, a 100 percent subsidiary of M/s.Eastern Car Liner, Japan.
                </p>
              </div>
            </Link>
            
            <Link to="/management-standards-vision" className="stats-panel-link">
              <div className="stats-panel-section">
                <h4 className="stats-panel-title">Management, Standards & Vision :</h4>
                <p className="stats-panel-text">
                  The Top management of the Company has a combined experience of more than ten decades in the Shipping Industry.
                </p>
              </div>
            </Link>
            
            <Link to="/joint-venture-partners" className="stats-panel-link">
              <div className="stats-panel-section">
                <h4 className="stats-panel-title">Joint Venture Partners :</h4>
                <p className="stats-panel-text">
                  ECL Shipping India Pvt Ltd is a Joint Venture company between ECL (SINGAPORE) PTE LTD and PUYVAST MARITIME INDIA PVT LTD.
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;